import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/copy-trading/page.tsx");
